import { GetAdminIdeasResponse } from '@orbit/api-types'
import { useAdminFilter } from '@pages/Admin/AdminFilterContext'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

interface UseAdminIdeasParams {
	page: number
	pageSize?: number
	/** Search by idea name; falsy values are omitted. */
	q?: string
}

/**
 * Fetches a page of the admin ideas list (GET /v1/admin/ideas), scoped to the
 * global creation-date range from {@link useAdminFilter} plus page and search term.
 * Previous data is kept while the next page loads. Gated server-side by AdminGuard.
 */
export const useAdminIdeas = ({ page, pageSize, q }: UseAdminIdeasParams) => {
	const { from, to, includeInternal } = useAdminFilter()

	return useQuery<GetAdminIdeasResponse>({
		queryKey: queryKeys.adminIdeas(from, to, page, pageSize, q, includeInternal),
		queryFn: async () => {
			const response = await api.get<GetAdminIdeasResponse>('/admin/ideas', {
				params: { from, to, page, pageSize, q: q || undefined, includeInternal: includeInternal || undefined },
			})
			return response.data
		},
		placeholderData: keepPreviousData,
	})
}
